import React from 'react';
import QuickSightDashBoard from './QuickSightDashBoard';

const DASHBOARD_IDS = {
    dev: "d9e411ed-982f-4139-a66d-c68155740932",
    alpha: "d9e411ed-982f-4139-a66d-c68155740932",
    prod: "33b72b0b-e07d-4d9e-ab0a-4f1a3dc89aae"
};

export default function BlueyDashboard() {
    return (
        <QuickSightDashBoard
            header="Bluey Management Dashboard"
            description=""
            dashboardIds={DASHBOARD_IDS}
        />
    );
}
